import { render, staticRenderFns } from "./TablePaginatedDamages.vue?vue&type=template&id=7a6b8f84&scoped=true"
import script from "./TablePaginatedDamages.vue?vue&type=script&lang=js"
export * from "./TablePaginatedDamages.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedDamages.vue?vue&type=style&index=0&id=7a6b8f84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b8f84",
  null
  
)

export default component.exports